export type DistanceUnits = 'Imperial' | 'Metric'

const MILES_PER_KILOMETRE = 0.6214

export const formatDistance = (distanceValue: number | null | undefined, units: DistanceUnits): string => {
  const value = distanceValue == null ? 0 : Math.max(0, distanceValue)
  const distance = units === 'Imperial' ? value * MILES_PER_KILOMETRE : value
  return distance.toFixed(2)
}
